import React from "react";
import TextField from "@material-ui/core/TextField";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from "@material-ui/core/FormControlLabel"
class ClientEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedTab: 0 }
  }
  update = (ev) => {
    let item = this.props.item;
    if (ev.target.id === 'setkm' || ev.target.id === 'setnights' || ev.target.id === 'setautograph' || ev.target.id === 'settravelhours' || ev.target.id === 'setpurchasenr'|| ev.target.id === 'setraceminutes'|| ev.target.id === 'inactive') {
      item[ev.target.id] = ev.target.checked
    } else {
      item[ev.target.id] = ev.target.value;
    }
    this.props.handleUpdate(item);
  }
  handleChangeStatusTab = (event, value) => {
    this.setState({ selectedTab: value })
  }
  render() {
    return (
      <React.Fragment>
        <AppBar position="static" color="secondary">
          <Tabs value={this.state.selectedTab} onChange={this.handleChangeStatusTab}>
            <Tab label="Algemeen" />
            <Tab label="Werkbon" />
          </Tabs>
        </AppBar>

        {
          this.state.selectedTab === 0
          &&

          <div className="padding">
            <TextField
              autoFocus
              margin="dense"
              id="clientnumber"
              label="Nummer"
              type="text"
              value={this.props.item.clientnumber || ""}
              onChange={this.update}
              fullWidth
              required
            />
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Naam"
              type="text"
              value={this.props.item.name || ""}
              onChange={this.update}
              fullWidth
              required
            />
            <TextField

              margin="dense"
              id="address"
              label="Adres"
              type="text"
              value={this.props.item.address || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField

              margin="dense"
              id="pobox"
              label="Postcode"
              type="text"
              value={this.props.item.pobox || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField

              margin="dense"
              id="town"
              label="Plaats"
              type="text"
              value={this.props.item.town || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField

              margin="dense"
              id="phone"
              label="Vaste nummer"
              type="text"
              value={this.props.item.phone || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField

              margin="dense"
              id="mobile"
              label="Mobiel nummer"
              type="text"
              value={this.props.item.mobile || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField

              margin="dense"
              id="contactperson"
              label="Contactpersoon"
              type="text"
              value={this.props.item.contactperson || ""}
              onChange={this.update}
              fullWidth
            />
            <TextField

              margin="dense"
              id="email"
              label="E-mailadres"
              type="text"
              value={this.props.item.email || ""}
              onChange={this.update}
              fullWidth
            />

            <FormControlLabel
              control={
                <Checkbox
                  id="inactive"
                  checked={this.props.item.inactive === true}
                  onChange={this.update}
                />}
              label="Inactief"
            />
          </div>

        }
        {
          this.state.selectedTab === 1
          &&
          <div className="padding">
            <FormControlLabel
              control={
                <Checkbox
                  id="setkm"
                  checked={this.props.item.setkm === true}
                  onChange={this.update}
                  value="0"
                />
              }
              label="Opgaaf van kilometers"
            />
            <br style={{ clear: 'both' }} />
            <FormControlLabel
              control={
                <Checkbox
                  id="setnights"
                  checked={this.props.item.setnights === true}
                  onChange={this.update}
                  value="0"
                />
              }
              label="Opgaaf aantal overnachtingen"
            />
            <br style={{ clear: 'both' }} />
            <FormControlLabel
              control={
                <Checkbox
                  id="settravelhours"
                  checked={this.props.item.settravelhours === true}
                  onChange={this.update}
                  value="0"
                />
              }
              label="Opgaaf aantal reisuren"
            />
            <br style={{ clear: 'both' }} />
            <FormControlLabel
              control={
                <Checkbox
                  id="setautograph"
                  checked={this.props.item.setautograph === true}
                  onChange={this.update}
                  value="0"
                />
              }
              label="Opgaaf handtekening"
            />
 <br style={{ clear: 'both' }} />
            <FormControlLabel
              control={
                <Checkbox
                  id="setraceminutes"
                  checked={this.props.item.setraceminutes === true}
                  onChange={this.update}
                  value="0"
                />
              }
              label="Opgaaf gasgeven"
            />

          </div>
        }
      </React.Fragment>
    );
  }
}
export default ClientEdit;
